import { useState, useEffect } from 'react';
import { useTimezone } from '../../hooks';

export const CurrentTime = () => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const timezone = useTimezone();

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const formattedTime = (() => {
        try {
            if (timezone && timezone !== 'UTC') {
                const formatter = new Intl.DateTimeFormat('en-US', {
                    timeZone: timezone,
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                });
                return formatter.format(currentTime);
            }
            return `${currentTime.getUTCHours().toString().padStart(2, '0')}:${currentTime.getUTCMinutes().toString().padStart(2, '0')}:${currentTime.getUTCSeconds().toString().padStart(2, '0')}`;
        } catch {
            return `${currentTime.getUTCHours().toString().padStart(2, '0')}:${currentTime.getUTCMinutes().toString().padStart(2, '0')}:${currentTime.getUTCSeconds().toString().padStart(2, '0')}`;
        }
    })();

    return (
        <span>{formattedTime}</span>
    );
};